import React, { Component } from "react";
import { connect } from "react-redux";
import EmptyColumn from "./EmptyColumn";
import SectionColumn from "./SectionColumns";
import SectionRow from "./SectionRow";
import SingleRow from "./SingleRow";

class PageSection extends Component {
    render() {
        const {
            setSectionRows={setSectionRows},
            sectionRowsLength,
            sectionId,
            formsRows,
            addnewItem,
            changeInputPosition,
            deleteInput,
            openInputConfig
        } = this.props;
        return (
            <div className="page__section">
                {formsRows.map((row) => {
                    const { rowId, rowColumns } = row;
                    let rowColumnsLength = rowColumns.length;
                    return (
                        <SectionRow
                            setSectionRows={setSectionRows}
                            rowColumnsLength={rowColumnsLength}
                            formsRows={formsRows}
                            sectionId={sectionId}
                            sectionRowsLength={sectionRowsLength}
                            rowId={rowId}
                            rowColumns={rowColumns}
                            addnewItem={addnewItem}
                            changeInputPosition={changeInputPosition}
                            deleteInput={deleteInput}
                            openInputConfig={openInputConfig}
                        />
                    );
                })}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lang: state.settings.language
    };
};
export default connect(mapStateToProps)(PageSection);
